import React, { useState, useEffect } from 'react';
import './Admin.css';
import PortfolioManager from './PortfolioManager';
import BrandsManager from './BrandsManager';
import ServicesManager from './ServicesManager';
import HistoryManager from './HistoryManager';
import AboutManager from './AboutManager';
import TrainingManager from "./TrainingManager";
const AdminPanel = () => {
    const [activeTab, setActiveTab] = useState('contacts');
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });


    // Контакты
    const [contacts, setContacts] = useState({
        phone: '',
        instagram: '',
        telegram: '',
        address: '',
        phone_visible: true,
        instagram_visible: true,
        telegram_visible: true,
        address_visible: true
    });

    // История
    const [history, setHistory] = useState({
        title: 'Моя история',
        paragraph_1: '',
        paragraph_2: '',
        paragraph_3: ''
    });

    // Загружаем данные
    useEffect(() => {
        loadAllData();
    }, []);

    const loadAllData = async () => {
        setLoading(true);
        await Promise.all([
            loadContacts(),
            loadHistory()
        ]);
        setLoading(false);
    };

    const loadContacts = async () => {
        try {
            const response = await fetch('/api/content/contacts');
            const data = await response.json();
            setContacts({
                phone: data.phone || '',
                instagram: data.instagram || '',
                telegram: data.telegram || '',
                address: data.address || '',
                phone_visible: data.phone_visible === 'true',
                instagram_visible: data.instagram_visible === 'true',
                telegram_visible: data.telegram_visible === 'true',
                address_visible: data.address_visible === 'true'
            });
        } catch (error) {
            console.error('Ошибка загрузки контактов:', error);
        }
    };

    const loadHistory = async () => {
        try {
            const response = await fetch('/api/content/history');
            const data = await response.json();
            setHistory({
                title: data.title || 'Моя история',
                paragraph_1: data.paragraph_1 || '',
                paragraph_2: data.paragraph_2 || '',
                paragraph_3: data.paragraph_3 || ''
            });
        } catch (error) {
            console.error('Ошибка загрузки истории:', error);
        }
    };

    const saveContacts = async () => {
        setSaving(true);
        try {
            const response = await fetch('/api/content/contacts', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    phone: contacts.phone,
                    instagram: contacts.instagram,
                    telegram: contacts.telegram,
                    address: contacts.address,
                    phone_visible: String(contacts.phone_visible),
                    instagram_visible: String(contacts.instagram_visible),
                    telegram_visible: String(contacts.telegram_visible),
                    address_visible: String(contacts.address_visible)
                })
            });

            if (response.ok) {
                setMessage({ text: '✅ Контакты успешно сохранены!', type: 'success' });
                setTimeout(() => setMessage({ text: '', type: '' }), 3000);
            } else {
                setMessage({ text: '❌ Ошибка при сохранении контактов', type: 'error' });
            }
        } catch (error) {
            setMessage({ text: '❌ Ошибка подключения к серверу', type: 'error' });
        } finally {
            setSaving(false);
        }
    };

    const saveHistory = async () => {
        setSaving(true);
        try {
            const response = await fetch('/api/content/history', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(history)
            });

            if (response.ok) {
                setMessage({ text: '✅ История успешно сохранена!', type: 'success' });
                setTimeout(() => setMessage({ text: '', type: '' }), 3000);
            } else {
                setMessage({ text: '❌ Ошибка при сохранении истории', type: 'error' });
            }
        } catch (error) {
            setMessage({ text: '❌ Ошибка подключения к серверу', type: 'error' });
        } finally {
            setSaving(false);
        }
    };

    const handleContactChange = (field, value) => {
        setContacts({ ...contacts, [field]: value });
    };

    if (loading) {
        return (
            <div className="admin-loading">
                <div className="spinner"></div>
                <p>Загрузка данных...</p>
            </div>
        );
    }

    return (
        <div className="admin-panel">
            <div className="admin-header">
                <h1>⚙️ Админ-панель</h1>
                <p>Управление контентом сайта</p>
            </div>

            {/* Табы */}
            <button className={`tab ${activeTab === 'about' ? 'active' : ''}`} onClick={() => setActiveTab('about')}>
                👤 Обо мне
            </button>
            <button
                className={`tab ${activeTab === 'services' ? 'active' : ''}`}
                onClick={() => setActiveTab('services')}
            >
                💇 Услуги
            </button>
            <button className={`tab ${activeTab === 'training' ? 'active' : ''}`} onClick={() => setActiveTab('training')}>
                📚 Обучение
            </button>

            <div className="admin-tabs">
                <button
                    className={`tab ${activeTab === 'contacts' ? 'active' : ''}`}
                    onClick={() => setActiveTab('contacts')}
                >
                    📞 Контакты
                </button>

                <button
                    className={`tab ${activeTab === 'portfolio' ? 'active' : ''}`}
                    onClick={() => setActiveTab('portfolio')}
                >
                    📸 Портфолио
                </button>

            </div>

            {message.text && (
                <div className={`message ${message.type}`}>
                    {message.text}
                </div>
            )}

            {activeTab === 'portfolio' && <PortfolioManager />}
            {activeTab === 'contacts' && (
                <div className="admin-section">
                    <h2>📞 Редактирование контактов</h2>
                    <p className="section-desc">Заполните контактные данные. Невидимые поля не будут отображаться на сайте.</p>

                    <div className="form-group">
                        <div className="field-header">
                            <label>📱 Телефон</label>
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    checked={contacts.phone_visible}
                                    onChange={(e) => handleContactChange('phone_visible', e.target.checked)}
                                />
                                Показывать на сайте
                            </label>
                        </div>
                        <input
                            type="text"
                            value={contacts.phone}
                            onChange={(e) => handleContactChange('phone', e.target.value)}
                            placeholder="+7 (999) 999-99-99"
                            className="form-input"
                        />
                    </div>

                    <div className="form-group">
                        <div className="field-header">
                            <label>📸 Instagram</label>
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    checked={contacts.instagram_visible}
                                    onChange={(e) => handleContactChange('instagram_visible', e.target.checked)}
                                />
                                Показывать на сайте
                            </label>
                        </div>
                        <input
                            type="text"
                            value={contacts.instagram}
                            onChange={(e) => handleContactChange('instagram', e.target.value)}
                            placeholder="@username"
                            className="form-input"
                        />
                    </div>

                    <div className="form-group">
                        <div className="field-header">
                            <label>💬 Telegram</label>
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    checked={contacts.telegram_visible}
                                    onChange={(e) => handleContactChange('telegram_visible', e.target.checked)}
                                />
                                Показывать на сайте
                            </label>
                        </div>
                        <input
                            type="text"
                            value={contacts.telegram}
                            onChange={(e) => handleContactChange('telegram', e.target.value)}
                            placeholder="@username"
                            className="form-input"
                        />
                    </div>

                    <div className="form-group">
                        <div className="field-header">
                            <label>📍 Адрес</label>
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    checked={contacts.address_visible}
                                    onChange={(e) => handleContactChange('address_visible', e.target.checked)}
                                />
                                Показывать на сайте
                            </label>
                        </div>
                        <input
                            type="text"
                            value={contacts.address}
                            onChange={(e) => handleContactChange('address', e.target.value)}
                            placeholder="г. Москва, ул. Примерная, д. 123"
                            className="form-input"
                        />
                    </div>

                    <div className="preview-box">
                        <h3>👁️ Предпросмотр контактов</h3>
                        <div className="preview-content">
                            {contacts.phone_visible && <div>📱 {contacts.phone || 'Не указан'}</div>}
                            {contacts.instagram_visible && <div>📸 {contacts.instagram || 'Не указан'}</div>}
                            {contacts.telegram_visible && <div>💬 {contacts.telegram || 'Не указан'}</div>}
                            {contacts.address_visible && <div>📍 {contacts.address || 'Не указан'}</div>}
                        </div>
                    </div>

                    <button
                        onClick={saveContacts}
                        disabled={saving}
                        className="save-btn"
                    >
                        {saving ? '💾 Сохранение...' : '💾 Сохранить контакты'}
                    </button>
                </div>
            )}

            {/* Вкладка История */}
            {activeTab === 'services' && <ServicesManager />}
            {activeTab === 'training' && <TrainingManager />}
            {activeTab === 'about' && <AboutManager />}
        </div>
    );
};

export default AdminPanel;